import React from 'react'
import { useParams } from 'react-router-dom'

import ViewOrder from '@components/order/ViewOrder'
import { FlexboxGrid } from 'rsuite'
import OrderStatusLabel from '@components/order/common/OrderStatusLabel'
import { useFetchSingleOrder } from '@@partner:graphql/query/order/singleOrder.gql'
import PaymentStatusLabel from '@components/order/payment/PaymentStatusLabel'
import AppLoader from '@components/common/AppLoader'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

export default function ViewOrderPage () {
  const { orderId } = useParams<any>()

  const { data, loading, error } = useFetchSingleOrder(orderId, '1200xauto')

  const order = data?.order
    
  if (loading) {
    return <AppLoader.RowsWithText content="Загружаем заказ" />
  }

  if (error) {
    return <GraphQLCommonErrorDisplay error={error} />
  }

  if (!order) {
    return <p>Order not found!</p>
  }

  return (
    <div className="ViewOrderPage">
      <FlexboxGrid align='middle'>
        <h1 className="u-heading">Заказ №{orderId}</h1>
        { order?.status && <OrderStatusLabel status={order?.status} /> }
        { order?.payment_status && <PaymentStatusLabel status={order?.payment_status} /> }
      </FlexboxGrid>
      <ViewOrder
        order={order}
      />
    </div>
  )
}
